module.exports = __webpack_public_path__ + "8411f21613e22430cbfa87d125364da8.svg";